import { Injectable } from '@angular/core';
import {
  ApplicationRoutesService,
  RouterLinks,
} from './application-routes.service';
import { ProductSource } from '../api/graphql/rfp/rfp-graphql.service';
import { Features } from '../types/features';

@Injectable({
  providedIn: 'root',
})
export class ProductDetailRouteService {
  constructor(private applicationRoutes: ApplicationRoutesService) {}

  get(
    routeParams: ProductDetailRouteParams,
    optionalParams: ProductDetailRouteOptionalParams,
  ): string {
    if (
      optionalParams.isSellerProduct &&
      routeParams.productSource === ProductSource.APTITUDE
    ) {
      if (optionalParams.features?.PRODUCT_PAGE_EDIT_CATALOG_883723) {
        return this.applicationRoutes.get(
          RouterLinks.CATALOG_PRODUCT_DETAIL,
          routeParams.categorizationSchemeId,
          routeParams.categoryId,
          routeParams.productId,
        );
      }
      return (
        this.applicationRoutes.get(
          RouterLinks.EDIT_PRODUCT_DETAIL,
          routeParams.productId,
        ) +
        `?categoryId=${routeParams.categoryId}&categorizationSchemeId=${routeParams.categorizationSchemeId}`
      );
    }

    return this.applicationRoutes.get(
      RouterLinks.CATALOG_PRODUCT_DETAIL,
      routeParams.categorizationSchemeId,
      routeParams.categoryId,
      routeParams.productId,
    );
  }
}

export interface ProductDetailRouteParams {
  categorizationSchemeId: number;
  categoryId: number;
  productId: number;
  productSource: string;
}

export interface ProductDetailRouteOptionalParams {
  features?: Features;
  isSellerProduct?: boolean;
}
